// extracted by mini-css-extract-plugin
module.exports = {"outOfStock":"productOutletRedirect_outOfStock__ksuPY","inStock":"productOutletRedirect_inStock__ny_KO"};